// ##############################################################

// #             GENEROVANÝ KÓD, NEMODIFIKOVAT!!!!              #

// #                  2025-05-15T11:49:17Z                      #

// ##############################################################

import {utils} from "@mc/mc-legacy";
const {ErrorApi, JsonFetch, Fetch, ParamsFetch, generateUrl} = utils;

import * as UpdateMethods from "./UpdateMethods";

/**
 * Created by Marbes Consulting jaroslav.hudec@marbes.cz / 20.08.2018. Generated from cz.marbes.cgo.controller.CiselnikController.
 */
export default class CiselnikApi {
    /**
     * Upload CSV souboru s číselníkem středisek. @param spolecnostId ID společnosti, pod kterou se má soubor založit @param obsahujeHlavicku zda jsou na prvním řádku názvy polí a tím pádem je přeskočit @param oddelovac oddělovač jednotlivých polí @param soubor soubory pro načtení @return mapa, kde klíčem je název souboru a hodnotou kód pro získání souboru
     *
     * @param spolecnostId 
     * @param obsahujeHlavicku 
     * @param oddelovac 
     * @param soubor 
     * @return java.lang.String
     */
    static testSouborStrediska(spolecnostId, obsahujeHlavicku, oddelovac, soubor) {
        const uri = serverContextPath + `/api/cgo/ciselnik/naklstrediska/testsoubor`;
        const headers = undefined;
        const params = { spolecnostId, obsahujeHlavicku, oddelovac,  };
         
        return ErrorApi.responseResolver(Fetch.put(uri, params, 0, headers));
    }

    /**
     * 
     *
     * @param danVO 
     * @return cz.marbes.cgo.controller.vo.DanVO
     */
    static createDan(danVO) {
        const uri = serverContextPath + `/api/cgo/ciselnik/dane`;
        const headers = undefined;
        const params = {  };
         
        return ErrorApi.responseResolver(JsonFetch.post(uri, params, danVO, headers));
    }

    /**
     * 
     *
     * @param ukonId 
     * @return cz.marbes.cgo.controller.vo.UkonVO
     */
    static getUkon(ukonId) {
        const uri = serverContextPath + `/api/cgo/ciselnik/ukon/${ukonId}`;
        const headers = undefined;
        const params = {  };
         
        return ErrorApi.responseResolver(JsonFetch.get(uri, params, headers));
    }

    /**
     * 
     *
     * @param pobockaId 
     * @return cz.marbes.cgo.controller.vo.PobockaVO
     */
    static getPobockaById(pobockaId) {
        const uri = serverContextPath + `/api/cgo/ciselnik/pobocka/${pobockaId}`;
        const headers = undefined;
        const params = {  };
         
        return ErrorApi.responseResolver(JsonFetch.get(uri, params, headers));
    }

    /**
     * 
     *
     * @param zpusobDopravaVO 
     * @param zpusobDopravaId 
     * @return cz.marbes.cgo.controller.vo.ZpusobDopravaVO
     */
    static updateZpusobDoprava(zpusobDopravaVO, zpusobDopravaId) {
        const uri = serverContextPath + `/api/cgo/ciselnik/zpusobydopravy/${zpusobDopravaId}`;
        const headers = undefined;
        const params = {  };
         
        return ErrorApi.responseResolver(JsonFetch.put(uri, params, zpusobDopravaVO, headers));
    }

    /**
     * 
     *
     * @param zpusobPlatbaVO 
     * @param zpusobPlatbyId 
     * @return cz.marbes.cgo.controller.vo.ZpusobPlatbaVO
     */
    static updateZpusobPlatba(zpusobPlatbaVO, zpusobPlatbyId) {
        const uri = serverContextPath + `/api/cgo/ciselnik/zpusobyplatby/${zpusobPlatbyId}`;
        const headers = undefined;
        const params = {  };
         
        return ErrorApi.responseResolver(JsonFetch.put(uri, params, zpusobPlatbaVO, headers));
    }

    /**
     * 
     *
     * @param neaktivni 
     * @return java.util.List<cz.marbes.cgo.controller.vo.DopravceVO>
     */
    static getDopravci(neaktivni) {
        const uri = serverContextPath + `/api/cgo/ciselnik/dopravci`;
        const headers = undefined;
        const params = { neaktivni };
         
        return ErrorApi.responseResolver(JsonFetch.get(uri, params, headers));
    }

    /**
     * 
     *
     * @param platbaIdPoradiMap 
     */
    static updatePoradiPlatby(platbaIdPoradiMap) {
        const uri = serverContextPath + `/api/cgo/ciselnik/zpusobyplatby/poradi`;
        const headers = undefined;
        const params = {  };
         
        return ErrorApi.responseResolver(JsonFetch.put(uri, params, platbaIdPoradiMap, headers));
    }

    /**
     * 
     *
     * @param zpusobDopravaVO 
     * @return cz.marbes.cgo.controller.vo.ZpusobDopravaVO
     */
    static createZpusobDoprava(zpusobDopravaVO) {
        const uri = serverContextPath + `/api/cgo/ciselnik/zpusobydopravy`;
        const headers = undefined;
        const params = {  };
         
        return ErrorApi.responseResolver(JsonFetch.post(uri, params, zpusobDopravaVO, headers));
    }

    /**
     * 
     *
     * @param pobockaVO 
     * @param pobockaId 
     * @return cz.marbes.cgo.controller.vo.PobockaVO
     */
    static updatePobocka(pobockaVO, pobockaId) {
        const uri = serverContextPath + `/api/cgo/ciselnik/pobocky/${pobockaId}`;
        const headers = undefined;
        const params = {  };
         
        return ErrorApi.responseResolver(JsonFetch.put(uri, params, pobockaVO, headers));
    }

    /**
     * 
     *
     * @param pobockaVO 
     * @return cz.marbes.cgo.controller.vo.PobockaVO
     */
    static createPobocka(pobockaVO) {
        const uri = serverContextPath + `/api/cgo/ciselnik/pobocky`;
        const headers = undefined;
        const params = {  };
         
        return ErrorApi.responseResolver(JsonFetch.post(uri, params, pobockaVO, headers));
    }

    /**
     * 
     *
     * @param neaktivni 
     * @return java.util.List<cz.marbes.cgo.controller.vo.UkonVO>
     */
    static getUkony(neaktivni) {
        const uri = serverContextPath + `/api/cgo/ciselnik/ukony`;
        const headers = undefined;
        const params = { neaktivni };
         
        return ErrorApi.responseResolver(JsonFetch.get(uri, params, headers));
    }

    /**
     * 
     *
     * @param zpusobDopravaId 
     * @param neaktivni 
     * @param datumDoruceni 
     * @return java.util.List<cz.marbes.cgo.controller.vo.TerminDopravaVO>
     */
    static getTerminyDopravy(zpusobDopravaId, neaktivni, datumDoruceni) {
        const uri = serverContextPath + `/api/cgo/ciselnik/zpusobdopravy/${zpusobDopravaId}/terminydopravy`;
        const headers = undefined;
        const params = { neaktivni, datumDoruceni };
         
        return ErrorApi.responseResolver(JsonFetch.get(uri, params, headers));
    }

    /**
     * 
     *
     * @param naklStredId 
     */
    static deleteNaklStred(naklStredId) {
        const uri = serverContextPath + `/api/cgo/ciselnik/naklstrediska/${naklStredId}`;
        const headers = undefined;
        const params = {  };
         
        return ErrorApi.responseResolver(JsonFetch.delete(uri, params));
    }

    /**
     * 
     *
     * @param terminDopravaVO 
     * @param zpusobDopravaId 
     * @param terminDopravaId 
     * @return cz.marbes.cgo.controller.vo.TerminDopravaVO
     */
    static updateTerminDoprava(terminDopravaVO, zpusobDopravaId, terminDopravaId) {
        const uri = serverContextPath + `/api/cgo/ciselnik/zpusobdopravy/${zpusobDopravaId}/termindopravy/${terminDopravaId}`;
        const headers = undefined;
        const params = {  };
         
        return ErrorApi.responseResolver(JsonFetch.put(uri, params, terminDopravaVO, headers));
    }

    /**
     * 
     *
     * @param zpusobPlatbaVO 
     * @return cz.marbes.cgo.controller.vo.ZpusobPlatbaVO
     */
    static createZpusobPlatba(zpusobPlatbaVO) {
        const uri = serverContextPath + `/api/cgo/ciselnik/zpusobyplatby`;
        const headers = undefined;
        const params = {  };
         
        return ErrorApi.responseResolver(JsonFetch.post(uri, params, zpusobPlatbaVO, headers));
    }

    /**
     * 
     *
     * @param zpusobPlatbyId 
     * @return cz.marbes.cgo.controller.vo.ZpusobPlatbaVO
     */
    static getZpusobPlatbyById(zpusobPlatbyId) {
        const uri = serverContextPath + `/api/cgo/ciselnik/zpusobplatby/${zpusobPlatbyId}`;
        const headers = undefined;
        const params = {  };
         
        return ErrorApi.responseResolver(JsonFetch.get(uri, params, headers));
    }

    /**
     * 
     *
     * @param danVO 
     * @param danId 
     * @return cz.marbes.cgo.controller.vo.DanVO
     */
    static updateDan(danVO, danId) {
        const uri = serverContextPath + `/api/cgo/ciselnik/dane/${danId}`;
        const headers = undefined;
        const params = {  };
         
        return ErrorApi.responseResolver(JsonFetch.put(uri, params, danVO, headers));
    }

    /**
     * 
     *
     * @param zpusobDopravaId 
     * @param terminDopravaVO 
     * @return cz.marbes.cgo.controller.vo.TerminDopravaVO
     */
    static createTerminDoprava(zpusobDopravaId, terminDopravaVO) {
        const uri = serverContextPath + `/api/cgo/ciselnik/zpusobdopravy/${zpusobDopravaId}/termindopravy`;
        const headers = undefined;
        const params = {  };
         
        return ErrorApi.responseResolver(JsonFetch.post(uri, params, terminDopravaVO, headers));
    }

    /**
     * 
     *
     * @param spolecnostId 
     * @return java.util.List<cz.marbes.cgo.controller.vo.NakladStredVO>
     */
    static getNaklStred(spolecnostId) {
        const uri = serverContextPath + `/api/cgo/ciselnik/naklstrediska`;
        const headers = undefined;
        const params = { spolecnostId };
         
        return ErrorApi.responseResolver(JsonFetch.get(uri, params, headers));
    }

    /**
     * 
     *
     * @param nakladStredVO 
     * @param naklStredId 
     * @return cz.marbes.cgo.controller.vo.NakladStredVO
     */
    static updateNaklStred(nakladStredVO, naklStredId) {
        const uri = serverContextPath + `/api/cgo/ciselnik/naklstrediska/${naklStredId}`;
        const headers = undefined;
        const params = {  };
         
        return ErrorApi.responseResolver(JsonFetch.put(uri, params, nakladStredVO, headers));
    }

    /**
     * 
     *
     * @param ukonVO 
     * @return cz.marbes.cgo.controller.vo.UkonVO
     */
    static createUkon(ukonVO) {
        const uri = serverContextPath + `/api/cgo/ciselnik/ukony`;
        const headers = undefined;
        const params = {  };
         
        return ErrorApi.responseResolver(JsonFetch.post(uri, params, ukonVO, headers));
    }

    /**
     * 
     *
     * @param ukonIdPoradiMap 
     */
    static updatePoradiUkonu(ukonIdPoradiMap) {
        const uri = serverContextPath + `/api/cgo/ciselnik/ukony/poradi`;
        const headers = undefined;
        const params = {  };
         
        return ErrorApi.responseResolver(JsonFetch.put(uri, params, ukonIdPoradiMap, headers));
    }

    /**
     * 
     *
     * @param naklStredId 
     * @return cz.marbes.cgo.controller.vo.NakladStredVO
     */
    static getNaklStredById(naklStredId) {
        const uri = serverContextPath + `/api/cgo/ciselnik/naklstredisko/${naklStredId}`;
        const headers = undefined;
        const params = {  };
         
        return ErrorApi.responseResolver(JsonFetch.get(uri, params, headers));
    }

    /**
     * 
     *
     * @param ipAdresa 
     * @return java.util.List<cz.marbes.cgo.controller.vo.PobockaVO>
     */
    static getPobockyDleIp(ipAdresa) {
        const uri = serverContextPath + `/api/cgo/ciselnik/pobocky/filtrip/${ipAdresa}`;
        const headers = undefined;
        const params = {  };
         
        return ErrorApi.responseResolver(JsonFetch.get(uri, params, headers));
    }

    /**
     * Výběr poboček (výdejních míst) pro tvorbu objednávky - zohledňuje nastavení výchozí pobočky u společnosti a případný filtr dle PSČ @param spolecnostId id společnosti pro přidání výchozího pobočky a vyhodnocení filtru PSČ dle výchozí adresy @param uzivatelId id uživatele pro vyhodnocení filtru PSČ dle výchozí adresy @return list odpovídajících poboček (výdejních míst)
     *
     * @param spolecnostId 
     * @param uzivatelId 
     * @return java.util.List<cz.marbes.cgo.controller.vo.PobockaSelectVO>
     */
    static getPobockyVydejSelect(spolecnostId, uzivatelId) {
        const uri = serverContextPath + `/api/cgo/ciselnik/pobockyvydejselect`;
        const headers = undefined;
        const params = { spolecnostId, uzivatelId };
         
        return ErrorApi.responseResolver(JsonFetch.get(uri, params, headers));
    }

    /**
     * 
     *
     * @param dopravaIdPoradiMap 
     */
    static updatePoradiDopravy(dopravaIdPoradiMap) {
        const uri = serverContextPath + `/api/cgo/ciselnik/zpusobydopravy/poradi`;
        const headers = undefined;
        const params = {  };
         
        return ErrorApi.responseResolver(JsonFetch.put(uri, params, dopravaIdPoradiMap, headers));
    }

    /**
     * 
     *
     * @param ukonVO 
     * @param ukonId 
     * @return cz.marbes.cgo.controller.vo.UkonVO
     */
    static updateUkon(ukonVO, ukonId) {
        const uri = serverContextPath + `/api/cgo/ciselnik/ukony/${ukonId}`;
        const headers = undefined;
        const params = {  };
         
        return ErrorApi.responseResolver(JsonFetch.put(uri, params, ukonVO, headers));
    }

    /**
     * Vrací true, pokud je zadaná pobočka aktivní a má ji nastavenou jako výchozí alespoň jedna společnost nebo uživatel. @param pobockaId ID pobočky @return true pokud alespoň jeden uživatel nebo společnost má danou pobočku zvolenou jako výchozí a pobočka je aktivní
     *
     * @param pobockaId 
     * @return boolean
     */
    static jePobockaAktivniAVychozi(pobockaId) {
        const uri = serverContextPath + `/api/cgo/ciselnik/pobocky/${pobockaId}/jeAktivniAVychozi`;
        const headers = undefined;
        const params = {  };
         
        return ErrorApi.responseResolver(JsonFetch.get(uri, params, headers));
    }

    /**
     * 
     *
     * @return cz.marbes.cgo.controller.vo.FirmaVO
     */
    static getFirma() {
        const uri = serverContextPath + `/api/cgo/ciselnik/firma`;
        const headers = undefined;
        const params = {  };
         
        return ErrorApi.responseResolver(JsonFetch.get(uri, params, headers));
    }

    /**
     * 
     *
     * @param atributVO 
     * @return cz.marbes.cgo.controller.vo.SouborAtributVO
     */
    static createSouborAtribut(atributVO) {
        const uri = serverContextPath + `/api/cgo/ciselnik/atributysouboru`;
        const headers = undefined;
        const params = {  };
         
        return ErrorApi.responseResolver(JsonFetch.post(uri, params, atributVO, headers));
    }

    /**
     * 
     *
     * @param neaktivni 
     * @param nevydejni 
     * @return java.util.List<cz.marbes.cgo.controller.vo.PobockaVO>
     */
    static getPobocky(neaktivni, nevydejni) {
        const uri = serverContextPath + `/api/cgo/ciselnik/pobocky`;
        const headers = undefined;
        const params = { neaktivni, nevydejni };
         
        return ErrorApi.responseResolver(JsonFetch.get(uri, params, headers));
    }

    /**
     * 
     *
     * @param spolecnostId 
     * @param neaktivni 
     * @return java.util.List<cz.marbes.cgo.controller.vo.ZpusobPlatbaVO>
     */
    static getZpusobyPlatby(spolecnostId, neaktivni) {
        const uri = serverContextPath + `/api/cgo/ciselnik/zpusobyplatby`;
        const headers = undefined;
        const params = { spolecnostId, neaktivni };
         
        return ErrorApi.responseResolver(JsonFetch.get(uri, params, headers));
    }

    /**
     * Upload CSV souboru s číselníkem středisek. @param spolecnostId ID společnosti, pod kterou se má soubor založit @param obsahujeHlavicku zda jsou na prvním řádku názvy polí a tím pádem je přeskočit @param oddelovac oddělovač jednotlivých polí @param soubor soubory pro načtení @return mapa, kde klíčem je název souboru a hodnotou kód pro získání souboru
     *
     * @param spolecnostId 
     * @param obsahujeHlavicku 
     * @param orezStrediskoKod 
     * @param orezStrediskoNazev 
     * @param oddelovac 
     * @param soubor 
     * @return java.lang.String
     */
    static nactiSouborStrediska(spolecnostId, obsahujeHlavicku, orezStrediskoKod, orezStrediskoNazev, oddelovac, soubor) {
        const uri = serverContextPath + `/api/cgo/ciselnik/naklstrediska/nactisoubor`;
        const headers = undefined;
        const params = { spolecnostId, obsahujeHlavicku, orezStrediskoKod, orezStrediskoNazev, oddelovac,  };
         
        return ErrorApi.responseResolver(Fetch.put(uri, params, 0, headers));
    }

    /**
     * 
     *
     * @param firmaVO 
     * @return cz.marbes.cgo.controller.vo.FirmaVO
     */
    static updateFirma(firmaVO) {
        const uri = serverContextPath + `/api/cgo/ciselnik/firma`;
        const headers = undefined;
        const params = {  };
         
        return ErrorApi.responseResolver(JsonFetch.put(uri, params, firmaVO, headers));
    }

    /**
     * 
     *
     * @param neaktivni 
     * @return java.util.List<cz.marbes.cgo.controller.vo.DanVO>
     */
    static getDane(neaktivni) {
        const uri = serverContextPath + `/api/cgo/ciselnik/dane`;
        const headers = undefined;
        const params = { neaktivni };
         
        return ErrorApi.responseResolver(JsonFetch.get(uri, params, headers));
    }

    /**
     * 
     *
     * @param dopravceVO 
     * @return cz.marbes.cgo.controller.vo.DopravceVO
     */
    static createDopravce(dopravceVO) {
        const uri = serverContextPath + `/api/cgo/ciselnik/dopravci`;
        const headers = undefined;
        const params = {  };
         
        return ErrorApi.responseResolver(JsonFetch.post(uri, params, dopravceVO, headers));
    }

    /**
     * 
     *
     * @param zpusobDopravaId 
     * @param dopravaTerminIdPoradiMap 
     */
    static updatePoradiTerminDoprava(zpusobDopravaId, dopravaTerminIdPoradiMap) {
        const uri = serverContextPath + `/api/cgo/ciselnik/zpusobydopravy/${zpusobDopravaId}/termindopravy/poradi`;
        const headers = undefined;
        const params = {  };
         
        return ErrorApi.responseResolver(JsonFetch.put(uri, params, dopravaTerminIdPoradiMap, headers));
    }

    /**
     * 
     *
     * @param nakladStredVO 
     * @return cz.marbes.cgo.controller.vo.NakladStredVO
     */
    static createNaklStred(nakladStredVO) {
        const uri = serverContextPath + `/api/cgo/ciselnik/naklstrediska`;
        const headers = undefined;
        const params = {  };
         
        return ErrorApi.responseResolver(JsonFetch.post(uri, params, nakladStredVO, headers));
    }

    /**
     * 
     *
     * @param atributVO 
     * @param souborAtributId 
     * @return cz.marbes.cgo.controller.vo.SouborAtributVO
     */
    static updateSouborAtribut(atributVO, souborAtributId) {
        const uri = serverContextPath + `/api/cgo/ciselnik/atributysouboru/${souborAtributId}`;
        const headers = undefined;
        const params = {  };
         
        return ErrorApi.responseResolver(JsonFetch.put(uri, params, atributVO, headers));
    }

    /**
     * 
     *
     * @param souborAtributId 
     * @return cz.marbes.cgo.controller.vo.SouborAtributVO
     */
    static getSouborAtribut(souborAtributId) {
        const uri = serverContextPath + `/api/cgo/ciselnik/atributysouboru/${souborAtributId}`;
        const headers = undefined;
        const params = {  };
         
        return ErrorApi.responseResolver(JsonFetch.get(uri, params, headers));
    }

    /**
     * 
     *
     * @param zpusobDopravaId 
     * @param terminDopravaId 
     * @return cz.marbes.cgo.controller.vo.TerminDopravaVO
     */
    static getTerminDopravyById(zpusobDopravaId, terminDopravaId) {
        const uri = serverContextPath + `/api/cgo/ciselnik/zpusobdopravy/${zpusobDopravaId}/termindopravy/${terminDopravaId}`;
        const headers = undefined;
        const params = {  };
         
        return ErrorApi.responseResolver(JsonFetch.get(uri, params, headers));
    }

    /**
     * 
     *
     * @param ipadresa 
     * @return java.util.List<cz.marbes.cgo.controller.vo.PobockaSelectVO>
     */
    static getPobockyOperatorSelect(ipadresa) {
        const uri = serverContextPath + `/api/cgo/ciselnik/pobockyoperatorselect`;
        const headers = undefined;
        const params = { ipadresa };
         
        return ErrorApi.responseResolver(JsonFetch.get(uri, params, headers));
    }

    /**
     * 
     *
     * @param dopravceId 
     * @return cz.marbes.cgo.controller.vo.DopravceVO
     */
    static getDopravceById(dopravceId) {
        const uri = serverContextPath + `/api/cgo/ciselnik/dopravce/${dopravceId}`;
        const headers = undefined;
        const params = {  };
         
        return ErrorApi.responseResolver(JsonFetch.get(uri, params, headers));
    }

    /**
     * 
     *
     * @param neaktivni 
     * @return java.util.List<cz.marbes.cgo.controller.vo.SouborAtributVO>
     */
    static getSouborAtributy(neaktivni) {
        const uri = serverContextPath + `/api/cgo/ciselnik/atributysouboru`;
        const headers = undefined;
        const params = { neaktivni };
         
        return ErrorApi.responseResolver(JsonFetch.get(uri, params, headers));
    }

    /**
     * 
     *
     * @param zpusobDopravaId 
     * @param terminDopravaId 
     */
    static deleteTerminDoprava(zpusobDopravaId, terminDopravaId) {
        const uri = serverContextPath + `/api/cgo/ciselnik/zpusobdopravy/${zpusobDopravaId}/termindopravy/${terminDopravaId}`;
        const headers = undefined;
        const params = {  };
         
        return ErrorApi.responseResolver(JsonFetch.delete(uri, params));
    }

    /**
     * 
     *
     * @param dopravceVO 
     * @param dopravceId 
     * @return cz.marbes.cgo.controller.vo.DopravceVO
     */
    static updateDopravce(dopravceVO, dopravceId) {
        const uri = serverContextPath + `/api/cgo/ciselnik/dopravci/${dopravceId}`;
        const headers = undefined;
        const params = {  };
         
        return ErrorApi.responseResolver(JsonFetch.put(uri, params, dopravceVO, headers));
    }

    /**
     * 
     *
     * @param neaktivni 
     * @return java.util.List<cz.marbes.cgo.controller.vo.ZpusobDopravaVO>
     */
    static getZpusobyDopravy(neaktivni) {
        const uri = serverContextPath + `/api/cgo/ciselnik/zpusobydopravy`;
        const headers = undefined;
        const params = { neaktivni };
         
        return ErrorApi.responseResolver(JsonFetch.get(uri, params, headers));
    }

    /**
     * 
     *
     * @param danId 
     * @return cz.marbes.cgo.controller.vo.DanVO
     */
    static getDanById(danId) {
        const uri = serverContextPath + `/api/cgo/ciselnik/dan/${danId}`;
        const headers = undefined;
        const params = {  };
         
        return ErrorApi.responseResolver(JsonFetch.get(uri, params, headers));
    }

    /**
     * 
     *
     * @param zpusobDopravaId 
     * @return cz.marbes.cgo.controller.vo.ZpusobDopravaVO
     */
    static getZpusobDopravyById(zpusobDopravaId) {
        const uri = serverContextPath + `/api/cgo/ciselnik/zpusobdopravy/${zpusobDopravaId}`;
        const headers = undefined;
        const params = {  };
         
        return ErrorApi.responseResolver(JsonFetch.get(uri, params, headers));
    }

    /**
     * 
     *
     * @param souborAtributIdPoradiMap 
     */
    static updatePoradiSouborAtributu(souborAtributIdPoradiMap) {
        const uri = serverContextPath + `/api/cgo/ciselnik/atributysouboru/poradi`;
        const headers = undefined;
        const params = {  };
         
        return ErrorApi.responseResolver(JsonFetch.put(uri, params, souborAtributIdPoradiMap, headers));
    }

    /**
     * Stažení loga firmy.
     *
     */
    static getLogoResource() {
        const uri = serverContextPath + `/api/cgo/ciselnik/firma/logo`;
        const headers = undefined;
        const params = {  };
         
        return ErrorApi.responseResolver(JsonFetch.get(uri, params, headers));
    }

    /**
     * 
     *
     * @param zpusobDopravaId 
     * @param terminDopravaId 
     * @return cz.marbes.cgo.controller.vo.TerminDopravaVO
     */
    static getTerminDopravy(zpusobDopravaId, terminDopravaId) {
        const uri = serverContextPath + `/api/cgo/ciselnik/zpusobdopravy/${zpusobDopravaId}/terminydopravy/${terminDopravaId}`;
        const headers = undefined;
        const params = {  };
         
        return ErrorApi.responseResolver(JsonFetch.get(uri, params, headers));
    }

}
